module.exports = __webpack_public_path__ + "static/media/arrowDown.ce43ec56.svg";